import {
  Button,
  Heading,
  List,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  type ModalProps,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

type DuplicatedEmailsModalProps = Omit<ModalProps, 'children'> & {
  duplicatedEmails: Array<string>;
};

export function DuplicatedEmailsModal({
  duplicatedEmails,
  ...props
}: DuplicatedEmailsModalProps) {
  const { t } = useTranslation(['candidate']);

  return (
    <Modal {...props} isCentered size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Heading fontSize="lg">
            {t('candidate:importByExcel.duplicatedEmailsModal.title')}
          </Heading>
          <ModalCloseButton />
        </ModalHeader>

        <ModalBody>
          <VStack align="stretch" spacing={4}>
            <Text fontSize="sm" color="gray.600">
              {t('candidate:importByExcel.duplicatedEmailsModal.description')}
            </Text>

            <List spacing={2} maxH="200px" overflowY="auto">
              {duplicatedEmails.map((email) => (
                <>
                  <ListItem
                    key={email}
                    p={2}
                    bg="gray.50"
                    borderRadius="md"
                    fontSize="sm"
                  >
                    {email}
                  </ListItem>
                </>
              ))}
            </List>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button variant="@primary" onClick={props.onClose}>
            {t('candidate:importByExcel.duplicatedEmailsModal.close')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
